import { motion } from "framer-motion";

/**
 * SectionLabel — premium pill-style heading eyebrow.
 * Sits at the top of every section as the first element visitors notice.
 */
export default function SectionLabel({ children, dark = false, dataTestId }) {
  return (
    <motion.span
      data-testid={dataTestId}
      initial={{ opacity: 0, scale: 0.6, y: 12 }}
      whileInView={{ opacity: 1, scale: 1, y: 0 }}
      viewport={{ once: true, amount: 0.25 }}
      transition={{ type: "spring", stiffness: 260, damping: 18, mass: 0.6 }}
      className={`inline-flex items-center gap-2.5 px-5 py-2 rounded-full font-display font-bold text-[13px] sm:text-sm md:text-[15px] uppercase tracking-[0.22em] ${
        dark
          ? "bg-orange-600 text-white shadow-[0_10px_28px_-10px_rgba(234,88,12,0.7)]"
          : "bg-orange-600 text-white shadow-[0_10px_28px_-10px_rgba(234,88,12,0.55)]"
      }`}
    >
      <span className="w-1.5 h-1.5 rounded-full bg-white/95 animate-pulse-soft" />
      {children}
    </motion.span>
  );
}
